import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { getAdsByUserID } from '../../actions/adActions';

// Components
import Spinner from '../common/Spinner';
import Transaction_Row from './Transaction_Row';
  
const Payment_Activity = ({
    auth: {
        user
    },
    ad,
    getAdsByUserID
}) =>  {

    // List
    const [list, setList] = useState([]);
    const [gotAds, setGotAds] = useState(false);

    useEffect(() => {
        
        if(user) {
            getAdsByUserID(user._id);
        }
    }, [user]);

    useEffect(() => {
    
        renderList();
    }, [ad.ads]);
    
    const renderList = () => {
        setList([]);

        if(ad.ads === null) {
            setList([(
                <Spinner />
            )])
        }
        else { 
            if(ad.ads.length > 0) {

                ad.ads.map(ad_obj => {
                    setList(list => [...list, (
                        <Transaction_Row
                            ad_details={ad_obj}
                        />
                    )])
                });

                setGotAds(true);
            } else {
                setList([(
                    <div className="no-rides">
                        <h1>No Transactions</h1>
                    </div>
                )])
            }
        } 
    }

    return (
	    <div className='order'>

            <div className='order__headerText'>
                <h3 className='line-clamp' style={{marginBottom: '5px', overflow:'hidden' , fontSize:'18px', fontWeight:'500', color:'#333', maxWidth:'100%'}}>
                    Payment Activity
                </h3>
            </div>

            {ad.ads?.length > 0 && (
                <div style={{width: '100%', display: 'flex', padding: '10px 0 0',}}>
                    <div style={{flex: 1}}>
                        <span style={{fontSize: '15px', fontWeight: 500}}>Date</span>
                    </div>
                    <div style={{flex: 1}}>
                        <span style={{fontSize: '15px', fontWeight: 500}}>Amount</span>
                    </div>
                    <div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
                        <span style={{fontSize: '15px', fontWeight: 500}}>Status</span>
                    </div>
                </div>
            )}

            {list}

            {/* <div className='order__headerDescription'>      
                <span className='hover_underline' style={{margin: '5px 0', width: 'fit-content', display: 'flex', color: 'rgb(29, 155, 240)', fontWeight: 500, cursor: 'pointer', zIndex: 10}}>See more activity</span>
            </div> */}

        </div>
	);
}
  

Payment_Activity.propTypes = {
    auth: PropTypes.object.isRequired,
    ad: PropTypes.object.isRequired,
    getAdsByUserID: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    ad: state.ad,
})

export default connect(mapStateToProps, {
    getAdsByUserID
})(Payment_Activity);

  